import { useEffect, useState } from "react";
import { DatePicker, Modal, Spin } from "antd";
import "./rescheduling-modal.scss";
import moment from "moment";
import { LoadingOutlined } from "@ant-design/icons";
import General from "../../../../stores/GeneralStore";
import { toJS } from "mobx";
import appointmentStore from "../../../../stores/AppointmentStore";
const ReschedulingModal = ({
  open,
  onClose,
  selectedData,
  handleReschedule,
  apptDetails,
}) => {
  const [selectedDate, setSelectedDate] = useState(null);
  const [fullDate, setFullDate] = useState(null);
  const [timeslots, setTimeSlot] = useState(null);
  const [selectedTimeSlot, setSelectedTimeSlot] = useState(null);
  const [loading, setLoading] = useState(false);
  const closeModal = () => {
    onClose();
  };
  const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;
  const handleDateChange = (date) => {
    if (date) {
      setFullDate(date.format("DD-MMM-YYYY"));
      setSelectedDate(date);
    } else {
      setFullDate(null);
    }
  };
  useEffect(()=>{
    setLoading(false);
  },[])
  useEffect(() => {
    if (fullDate) {
      async function fetch_timeslots() {
        let timeslots = await appointmentStore.getSlotsList({ errorId: 'getServiceListError', data:{branchCode:'01',date:moment(fullDate).format("YYYY-MM-DD")} });
        setTimeSlot(timeslots.data);
      }

      fetch_timeslots();
    }
  }, [fullDate]);

  const handlerReschedule = async () => {
    // Find the corresponding appointment in apptDetails array
    console.log(toJS(apptDetails))
    console.log('hha',toJS(selectedData))
    const matchingAppointment = apptDetails?.find(
      (appointment) => appointment?.indAppt?.apptCode === selectedData?.indAppt?.apptCode
    );
  console.log(toJS(matchingAppointment))
    if (matchingAppointment) {
      setLoading(true);
      // Code to handle reschedule action
      const payload = {
        branchCode: matchingAppointment.indBranch.branchCode,
        serviceCode: matchingAppointment.service.indService
          ? matchingAppointment.service.indService.serviceNo
          : null,
        name: matchingAppointment.cust.indCust.name,
        syncId: matchingAppointment.cust.mobilePhoneNumber,
        mobilePhoneNumber: matchingAppointment.cust.mobilePhoneNumber,
        apptCode: matchingAppointment.indAppt.apptCode,
        apptDate: selectedTimeSlot,
        apptTime: selectedTimeSlot,
        startTime: selectedTimeSlot,
      };

      const response = await handleReschedule(payload);
      setTimeout(()=>{setLoading(false)},5000)
      if (response.data.statusCode === 200) {
        closeModal();
        setLoading(false);
        setSelectedDate("");
        setSelectedTimeSlot("");
      }
    }
  };
  const disabledDate = (current) => {
    // Disable dates before today or after two months from today
    return (
      current &&
      (current < moment().startOf("day") ||
        current > moment().add(2, "months").endOf("day") ||
        current.day() === 0 ||
        current.day() === 6)
    );
  };
  return (
    <Modal
      className="reschedule-modal"
      open={open}
      centered
      onCancel={closeModal}
      closable={false}
      destroyOnClose={true}
      footer={null}
      zIndex={999}
    >
      <div className="modal-content-wrapper">
        <div className="etoken-form-wrapper-content-wrapper-field-selection">
          <div className="etoken-form-wrapper-content-wrapper-field-selection-date">
            <span
              style={{
                color: "",
              }}
              className="etoken-form-wrapper-content-wrapper-field-selection-date-label"
            >
              {General?.codeLabels["cm_pdc_dateval"]?.label?General?.codeLabels["cm_pdc_dateval"]?.label:"Select"}
            </span>
            <div className="etoken-form-wrapper-content-wrapper-field-selection-date-picker">
              <DatePicker
                value={selectedDate}
                disabledDate={disabledDate}
                onChange={handleDateChange}
              />
            </div>
          </div>
          <div className="etoken-form-wrapper-content-wrapper-field-selection-time">
            <span
              style={{
                color: "",
              }}
              className="etoken-form-wrapper-content-wrapper-field-selection-time-label"
            >
              {General?.codeLabels["cm_selct_tileslot"]?.label?General?.codeLabels["cm_selct_tileslot"]?.label:"Select a Timeslot"}
            </span>
            <span>
              <select
                className="etoken-form-wrapper-content-wrapper-field-selection-time-dropdown"
                value={selectedTimeSlot}
                disabled={fullDate ? false : true}
                onChange={(e) => setSelectedTimeSlot(e.target.value)}
              >
                <option value="">{General?.codeLabels["cm_pdc_select"]?.label?General?.codeLabels["cm_pdc_select"]?.label:"Select"}</option>
                {
                appointmentStore.slotsList.map((slot) => {
                  return <option value={slot.apptSlot.startTime}>{slot.apptSlot.startTime.split("T")[1]}</option>
                })
              }
              </select>
            </span>
          </div>
        </div>
        <div className="reschedule-btn">
          <button
            style={{ backgroundColor: "" }}
            onClick={() => handlerReschedule()}
          >
            {loading ? (
              <div className="spin" style={{ height: "unset" }}>
                <Spin className="spin-antd" indicator={antIcon} />
              </div>
            ) : (
              "Reschedule"
            )}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ReschedulingModal;
